import getHexConsumerIdForUser from '../actions/getHexConsumerIdForUser';
import getPersonaPhotoUrl from '../utils/getPersonaPhotoUrl';
import { getPersonaPhotoUrlFromhexCID } from '../utils/getPersonaPhotoUrl';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { PersonaIdentifiers } from 'owa-persona/lib/personaConfig';
import getTokenForImageApi from 'owa-persona/lib/utils/getTokenForImageApi';

export default function getAndPrefetchPersonaImageUri(
    personaId: PersonaIdentifiers,
    callback: (uri?: string, headers?: { [key in string]: string }, error?: string) => void,
    imageStyle?: string
): void {
    const hexCid: string = getHexConsumerIdForUser(personaId.Smtp);
    let headers = {};
    getTokenForImageApi().then((token: string) => {
        if (token) {
            headers = {
                Authorization: `Bearer ${token}`,
                'X-AnchorMailbox': personaId.Smtp,
            };
        }
        const mailboxType = personaId.PersonaType == 'Group' ? 'GroupMailbox' : undefined;
        callback(
            hexCid
                ? getPersonaPhotoUrlFromhexCID(hexCid, mailboxType, PersonaSize.regular)
                : getPersonaPhotoUrl(personaId.Smtp, personaId.OlsPersonaId, mailboxType, true),
            headers
        );
    });
}
